<template>
  <v-container class="pt-0 pb-0">
    <v-select
      :disabled="disabled"
      v-model="selectorSelection"
      :items="selectorOptions"
      item-text="name"
      item-value="id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="false"
      :chips="true"
      deletable-chips
      :small-chips="true"
      :hide-details="true"
      label="Location Precision"
      multiple
      @change="handleValueChangeInside"
    >
    </v-select>
  </v-container>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";
import lodashHas from "lodash/has";
import { formatBigNumber } from "@/common/basic.utilities";

import {
  GEOLOCATION_PRECISIONS,
  filterPrecisionsByEventType,
} from "@/common/constants/geolocationPrecisions.js";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "SearchFilterGeolocationPrecision",
  props: {
    type: {
      type: String,
    },
    given: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    geolocationPrecisionFilterCounts: {
      type: Object,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      selectorSelection: [],
      localSelected: [],
      prevSelected: [],
    };
  },
  computed: {
    selectorOptions() {
      let options = filterPrecisionsByEventType(this.type);
      options.forEach((option) => {
        if (
          this.geolocationPrecisionFilterCounts &&
          lodashHas(this.geolocationPrecisionFilterCounts, option.name)
        ) {
          option.name = `${option.name} (${formatBigNumber(
            this.geolocationPrecisionFilterCounts[option.name]
          )})`;
        }
      });
      return options;
    },
  },
  mounted() {
    this.handleValueChange();
  },
  methods: {
    handleValueChange(opts = {}) {
      this.prevSelected = JSON.parse(JSON.stringify(this.selectorSelection));
      if (this.given) {
        this.localSelected = this.given;
        this.selectorSelection = this.given;
      } else {
        this.localSelected = [];
        this.selectorSelection = [];
      }
      this.selectorSelection = JSON.parse(JSON.stringify(this.localSelected));
    },
    handleValueChangeInside(a, b, c) {
      let optionsForActiveType = filterPrecisionsByEventType(this.type).map(
        (precision) => {
          return precision.id;
        }
      );

      let selectorSelection = lodashCloneDeep(this.selectorSelection);

      let optionsAbscentActiveType = GEOLOCATION_PRECISIONS.filter((cur) => {
        return !optionsForActiveType.includes(cur.id);
      }).map((precision) => {
        return precision.id;
      });

      let selectedPrecisionsIncompatibleWithEventType = lodashCloneDeep(
        this.given
      ).filter((cur) => {
        return optionsAbscentActiveType.includes(cur);
      });

      let valuesSelectedToConsider = lodashCloneDeep(selectorSelection).filter(
        (cur) => {
          return !optionsAbscentActiveType.includes(cur);
        }
      );

      let allSelected = valuesSelectedToConsider.concat(
        selectedPrecisionsIncompatibleWithEventType
      );

      this.$emit(EMITTED_ACTIONS.CHANGE, allSelected);
    },
  },
  watch: {
    given: {
      handler() {
        this.handleValueChange();
      },
    },
    reset: {
      handler() {
        this.selectorSelection = [];
        this.localSelected = [];
        this.prevSelected = [];
        this.handleValueChangeInside();
      },
    },
  },
};
</script>

<style scoped></style>
